



import { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { FlexLayoutUnit } from './types';
import { CSSStyleOptions } from '../common-types';
import { utilService } from '../util-service';

const cssPrefix = 'sw-flex-layout';
const swFlexboxRulePrefix = 'sw-flexbox';

/**
 * Flexbox-based layout component.
 *
 * Internally it is leveraging our pre-defined `sw-flexbox` series css rules in order for
 * consistency and normalization.
 */
@Component({
  components: {},
})
export default class SwFlexLayout extends SwExtendedVue {
  @Prop({ type: Object, required: true })
  spec: FlexLayoutUnit;

  cssPrefix =  cssPrefix;

  private renderLayoutUnit(h: CreateElement, unit: FlexLayoutUnit): VNode {
    const itemNodes: VNode[] = [];
    const rootClasses: string[] = [];
    const rootStyle: CSSStyleOptions = {};

    if (!!unit.className) {
      rootClasses.push(unit.className);
    }

    if (!!unit.container) {
      unit.container.items.forEach((item) => {
        itemNodes.push(this.renderLayoutUnit(h, item));
      });

      rootClasses.push(`${swFlexboxRulePrefix}`);
      rootClasses.push(`${swFlexboxRulePrefix}--${unit.container.direction || 'row'}`);
      if (unit.container.wrap === true) { rootClasses.push(`${swFlexboxRulePrefix}--wrap`); }
      rootClasses.push(`${swFlexboxRulePrefix}--${unit.container.justifyContent || 'start'}-justify`);
      rootClasses.push(`${swFlexboxRulePrefix}--${unit.container.alignItems || 'stretch'}-items`);
      rootClasses.push(`${swFlexboxRulePrefix}--${unit.container.alignContent || 'start'}-content`);
    }

    if (!!unit.item) {
      rootClasses.push(`${swFlexboxRulePrefix}__flex${unit.item.flex === false ? '-none' : ''}`);
      rootStyle.order = typeof unit.item.order === 'number' ? `${unit.item.order}` : '0';
      if (!!unit.item.explicitFlex) {
        if (unit.item.explicitFlex.grow !== undefined) { rootStyle.flexGrow = `${unit.item.explicitFlex.grow}`; }
        if (unit.item.explicitFlex.shrink !== undefined) { rootStyle.flexShrink = `${unit.item.explicitFlex.shrink}`; }
        if (unit.item.explicitFlex.basis !== undefined) { rootStyle.flexBasis = `${unit.item.explicitFlex.basis}`; }
      }
    }

    return (
      <div class={rootClasses} style={rootStyle}>
      { itemNodes.length > 0 ? itemNodes : utilService.getVueScopedSlot(this.$scopedSlots, unit.id) }
      </div>
    ) as VNode;
  }

  private render(h: CreateElement): VNode {
    return this.renderLayoutUnit(h, this.spec);
  }
}
